// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = ({
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px 30px',
    borderRadius: 15,
    maxWidth: 300,
    position: 'relative',
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
  },
  title: {
    textAlign: 'center',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    color: GlobalStyles.color.COLOR_GREY,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    padding: '0 30px',
  },
  buttonsContainer: {
    display: 'flex',
  },
  buttonStyle: {
    width: 100,
    minWidth: 100,
  },
  buttonCancel: {
    background: 'none',
  },
  closeIconContainer: {
    position: 'absolute',
    top: 10,
    right: 5,
    backgroundColor: 'transparent',
    border: 'none',
    '&:focus': {
      outline: 'none',
    },
  },
  closeIcon: {
    width: 25,
    height: 25,
  }
});

export default styles;
